import { useDispatch, useSelector } from "react-redux";
import { closeErrorModal } from "../store/slices/errorModalSlice";
import { ReactComponent as InfoTriangle } from "../assets/ErrorModal/danger.svg";
import { ReactComponent as InfoCircle } from "../assets/ErrorModal/info-circle.svg";
import { RefetchFunction } from "src/types/shared.types";
import type { RootState } from "../store";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import translation from "../data/fa-IR.json";

//Handling Refetch Func
let retryFunctionRef: RefetchFunction | null = null;
export const setErrorRetryFunction = (fn: RefetchFunction) => {
  retryFunctionRef = fn;
};

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { isOpen, title, detail, method } = useSelector(
    (state: RootState) => state.errorModal
  );

  const handleClose = () => {
    dispatch(closeErrorModal());
  };

  const handleRetry = () => {
    handleClose();
    if (typeof retryFunctionRef === "function") {
      retryFunctionRef();
    }
  };

  const isNetworkError =
    title === translation.Global.Warnning &&
    detail === translation.Global.NetworkError;

  return (
    <Dialog
      open={isOpen}
      disableEscapeKeyDown
      PaperProps={{
        elevation: 0,
      }}
      sx={{
        "& .MuiPaper-root": {
          borderRadius: (theme) => theme.spacing(8),
          backgroundColor: "background.primary",
          border: (theme) => `1px solid ${theme.palette.border.secondary}`,
          color: "text.primary",
          fontWeight: 700,
          padding: "24px",
          width: "100%",
          height: "auto",
        },
        "& .MuiDialogTitle-root": {
          "@media (min-width:600px)": {
            fontSize: "22px",
          },
        },
        "& .MuiDialogActions-root": {
          justifyContent: "left",
        },
      }}
    >
      <DialogTitle>
        {isNetworkError ? <InfoCircle /> : <InfoTriangle />}
      </DialogTitle>

      <DialogContent
        sx={{
          fontSize: "16px",
          fontWeight: 700,
          "@media (min-width:600px)": {
            fontSize: "18px",
          },
        }}
      >
        {title}
      </DialogContent>

      <DialogContent
        sx={{
          fontSize: "14px",
          fontWeight: 300,
          "@media (min-width:600px)": {
            fontSize: "16px",
          },
        }}
      >
        {detail}
      </DialogContent>

      <DialogActions>
        <Button
          sx={{
            "&:hover": { backgroundColor: "transparent" },
            border: (theme) => `1px solid ${theme.palette.border?.primary}`,
            color: (theme) =>
              isNetworkError
                ? theme.palette.text.infoPrimary
                : theme.palette.error.main,
            fontWeight: 300,
            fontSize: "14px",
            "@media (min-width:600px)": {
              fontSize: "16px",
            },
          }}
          onClick={method === "GET" ? handleRetry : handleClose}
        >
          {method === "GET"
            ? translation.Global.Retry
            : translation.Global.Understood}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorModal;
